export default __webpack_public_path__ + "static/media/car.222a5c22.webp";